export const filterTabItems = (tabItems, key) => {
  const updatedTabItems = tabItems.filter(item => item.key !== key);

  return updatedTabItems;
};
